import { createFileRoute } from '@tanstack/react-router';
import { CheckEmailPage } from '../components/auth/CheckEmailPage';

export const Route = createFileRoute('/check-email')({
  component: CheckEmail,
});

function CheckEmail() {
  return <CheckEmailPage />;
}
